import React, { FC } from 'react';
import { Box } from '@bechtel/gds';
import { Text } from '@bechtel/gds';
import { Spinner } from '@bechtel/gds';
import { Modal, ModalHeader, ModalBody, ModalFooter, useModalState, Button, ButtonAppearance } from '@bechtel/gds';
import { ApolloError, useLazyQuery } from '@apollo/client';
import { PlanningFilterInput, PlanningWeek, PersonaType } from '@bechtel/types';
import { GET_PLANNED_MILESTONES } from '@bechtel/client-gql';
import { usePlanning, AllForemanId, UnassignedForemanId, useConfig } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';

interface SavePlanErrorProps {
  savePlanError: ApolloError;
}

export const SavePlanError: FC<SavePlanErrorProps> = () => {
  const { numPlanningNextWeeks } = useConfig();
  const { visible, close } = useModalState(true);
  const { selectedForeman } = usePlanning();
  const [getPlannedMilestones, { loading }] = useLazyQuery<
    { plannedMilestones: PlanningWeek[] },
    {
      input: PlanningFilterInput;
    }
  >(GET_PLANNED_MILESTONES, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });

  return (
    <Modal visible={visible}>
      <ModalHeader title="Save Plan Error"></ModalHeader>
      <ModalBody>
        <Box px={{ sm: '500' }} py={{ sm: '700' }}>
          <Text size="600">
            <Trans>
              Error occurred saving the plan.Please press the &ldquo;Update&rdquo; button to fetch the latest data and
              try again.
            </Trans>
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
          <Box>
            <Button
              type="submit"
              appearance={ButtonAppearance.SECONDARY}
              onClick={async () => {
                if (
                  selectedForeman &&
                  selectedForeman.persona === PersonaType.FOREMAN &&
                  selectedForeman.id !== UnassignedForemanId &&
                  selectedForeman.id !== AllForemanId
                ) {
                  await getPlannedMilestones({
                    variables: {
                      input: {
                        persona: selectedForeman.persona,
                        crewMemberId: selectedForeman.id,
                        numNextWeeks: numPlanningNextWeeks,
                      },
                    },
                  });
                }
                close();
              }}
              disabled={loading}
            >
              {loading && <Spinner></Spinner>}
              {!loading && <Trans>Update</Trans>}
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
